import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { WeighReportContent } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPdf from "react-to-pdf";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { DailyCollectionCategoryObject } from '../DailyCollectionCategorySchema';
import { validateProperty, validate } from "../../../Common";
import divisionService from '../../../Devision/services';
import groupService from '../../../Group/services';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'CHECKROLLWEIGHMENTREPORT';

export function WeighListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [estates, setEstates] = useState();
    const [divisions, setDivisions] = useState();
    const [fields, setFields] = useState();
    const [errors, setErrors] = useState({});
    const [sessions, setSessions] = useState({});
    const [totalSummaryRow, setTotalSummaryRow] = useState([]);
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };

    const schema = Joi.object(DailyCollectionCategoryObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [collectionCategoryReport, setcollectionCategoryReport] = useState([])
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0",
            searchDate: ""
        }
    );

    const [contentRowNames, setContentRowNames] = useState(["epfNo",
        "firstName", "collectionPointName", "fieldName", "gangName", "sosTime"
        , "weightReadTime", "actualAmount", "totalDeduction", "grossAmount",
        "netAmount", "extraKg", "profit"])
    const [isTableHide, setIsTableHide] = useState(true);
    const [excelData, setExcelData] = useState([]);
    const [deductionTypeNamesOfTable, setDeductionTypeNamesOfTable] = useState([]);
    const [feildAvailabeDedauctionTypes, setFeildAvailabeDedauctionTypes] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        estate: "",
        division: "",
        feild: "",
        session: "",
        date: ""
    })
    const initialContentRowNames = ["", "epfNo", "firstName",
        "collectionPointName", "fieldName", "gangName", "sosTime"
        , "weightReadTime", "actualAmount", "gps", "grossAmount", "netAmount", "extraKg", "profit", "tareWeight"];
    const initialCsvHeaders = [
        { label: "EPF No", value: "epfNo" },
        { label: "FirstName", value: "firstName" },
        { label: "Division", value: "collectionPointName" },
        { label: "Field", value: "fieldName" },
        { label: "Gang", value: "gangName" },
        { label: "Session", value: "sosTime" },
        { label: "WeightRead Time", value: "weightReadTime" },
        { label: "Actual Amount (Kg) Net", value: "actualAmount" },
        { label: "GPS", value: "gps" },
        { label: "Net Amount (Kg)", value: "grossAmount" },
        { label: "Checkroll Amount (Kg)", value: "netAmount" },
        { label: "Extra Kg(Kg)", value: "extraKg" },
        { label: "Gain/ Loss (Kg)", value: "profit" },
        { label: "Tare Weight", value: "tareWeight" }
    ];
    const [csvHeaders, setCsvHeaders] = useState([]);

    const [detailCard, setDetailCard] = useState({
        gross: 0,
        net: 0,
        total: 0,
        gainloss: 0
    });
    const [detailDeductions, setDetailDeductions] = useState([]);
    const [footerTotalRowExcel, setFooterTotalRowExcel] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            setGroupDropDownData()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown(),
            getDeductionTypesForTable()
        )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            GetDivisionForDropDown(),
            getMobileSessions()
        )
    }, [searchForm.estateID]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.divisionID]);

    useEffect(() => {
        destroyDataTable();
        setIsTableHide(false);
        createDataTable();
    }, [collectionCategoryReport]);

    useEffect(() => {
        trackPromise(
            getFeildsByCollectionPoint(),
            getMobileSessions()
        )
    }, [searchForm.searchDate]);

    useEffect(() => {
        trackPromise(
            getMobileSessions()
        )
    }, [searchForm.fieldID]);

    async function getMobileSessions() {
        if (searchForm.searchDate !== "")
            getMobileSessionsForDropDown();
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWWEIGHNINGREPROT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function getDeductionTypesForTable() {
        const deductionTypeNames = await services.GetAllDedtuctionTypeNames();
        setDeductionTypeNamesOfTable(deductionTypeNames);
    }

    async function setGroupDropDownData() {
        const result = await groupService.getGroupsForDropdown();
        setGroups(result);
    }

    async function getEsatesForDropDown() {
        const factoryList = await divisionService.getEstatesByGroupID(searchForm.groupID);
        setEstates(factoryList);
    }

    async function GetDivisionForDropDown() {
        const routeList = await services.GetDivisionByEstateID(searchForm.estateID);
        setDivisions(routeList);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(searchForm);
        setFields(fields);
    }

    async function getMobileSessionsForDropDown() {
        const selectedSessions = await services.GetMobileSessionsForWeighReport(searchForm);
        setSessions(selectedSessions);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, DailyCollectionCategoryObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            divisionID: target.value,
            fieldID: "0",
            sessionID: "0"
        });
    }

    function handleDateChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: "0",
            sessionID: "0",
            searchDate: target.value
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);

        setSearchForm({
            ...searchForm,
            fieldID: target.value,
            sessionID: "0"
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyCollectionCategoryObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }

    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchForm);
        var reportData = await services.GetWeighReportData(searchForm);

        var weighReport = reportData.weighReportsData;
        var deductionTypes = reportData.availableDeduction;

        deductionTypes.forEach((val, index) => deductionTypes[index] = val.deductionTypeName);

        setFeildAvailabeDedauctionTypes(deductionTypes);

        let groupedResult = groupBySubsession(weighReport);

        let keys = Object.keys(groupedResult);
        let arrayCollection = [];

        keys.forEach(x => {
            var res = mergeDataByBag(groupedResult[x], deductionTypes);
            if (res.length !== 0)
                arrayCollection.push(res);
        });

        let rowNames = initialContentRowNames;
        let headerNames = initialCsvHeaders;

        rowNames.splice(10, 0, ...deductionTypes);

        deductionTypes.forEach((x, i) => {
            headerNames.splice((9 + i), 0, { label: x, value: x },);
        })

        setContentRowNames(rowNames);
        setCsvHeaders(headerNames);

        if (arrayCollection.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }
        setFooterTotalRowExcel(generateFooterTotalRow(arrayCollection));
        setcollectionCategoryReport(arrayCollection);
        generateSummaryCard(arrayCollection, deductionTypes);
        setDataForExcelData(arrayCollection)
    }

    

    function generateFooterTotalRow(data) {
        var totalRow = [];
        data.forEach(sessionData => {
            sessionData.forEach(y => {
                if (totalRow.length === 0) {
                    var newRecord = refactorFooterTotalRecord(y);
                    totalRow.push(newRecord);
                } else {

                    var duplicateRecord = totalRow.find(a => a.mobileSubSessionID === y.mobileSubSessionID);

                    if (duplicateRecord) {
                        for (const property in y) {
                            if (property !== "mobileSubSessionID") {
                                duplicateRecord[property] = checkUndifinedAndNaN(duplicateRecord[property]) + checkUndifinedAndNaN(y[property]);
                            }
                        }
                    } else {
                        var newRecord = refactorFooterTotalRecord(y);
                        totalRow.push(newRecord);
                    }
                }
            })
        });
        setTotalSummaryRow(totalRow);
        return totalRow;
    }

    function refactorFooterTotalRecord(y) {
        var newRecord = {}
        for (const property in y) {
            if (property === "mobileSubSessionID") {
                newRecord.mobileSubSessionID = y.mobileSubSessionID;
            }
            else {
                newRecord[property] = checkUndifinedAndNaN(y[property]);
            }
        }
        return newRecord;
    }

    function checkUndifinedAndNaN(value) {
        if (value === undefined || value === NaN) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Check Roll Weighment',
            fileName: 'CheckRollWeighmentReport',
            writeOptions: {}
        }
        var copyOfCsv = _.cloneDeep(excelData, footerTotalRowExcel)
        var newRow1 = {
            epfNo: "Group :" + selectedSearchValues.group,
            collectionPointName: "Estate : " + selectedSearchValues.estate,
            firstName: "Division : " + selectedSearchValues.division,
        }
        var newRow2 = {
            epfNo: "Feild : " + selectedSearchValues.feild,
            collectionPointName: "Session : " + selectedSearchValues.session,
            firstName: "Date : " + selectedSearchValues.date

        }
        copyOfCsv.push({}, {}, newRow1)
        copyOfCsv.push(newRow2)
        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function groupBySubsession(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['mobileSubSessionID']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function mergeDataByBag(data, deductionTypes) {

        var result = [];
        var extraKgRecords = [];

        let groupedResult = groupByDetailsID(data);

        let keys = Object.keys(groupedResult);
        let arrayCollection = [];

        keys.forEach(x => {
            var res = mergeDataByDetailsID(groupedResult[x]);
            if (res.length !== 0)
                arrayCollection.push(res);
        });

        arrayCollection.forEach(d => {
            var selectedRecord = result.filter(e =>
                e.pluckingCollectionID === d.pluckingCollectionID);

            if (selectedRecord.length === 0) {
                if (d.extraKg === 0) {
                    result.push(d);
                }
                else {
                    var exsitingExtraKg = extraKgRecords.filter(x => x.employeeID === d.employeeID);

                    if (exsitingExtraKg.length === 0) {
                        extraKgRecords.push({ id: d.employeeID, extraKgTot: d.extraKg });
                    } else {
                        exsitingExtraKg[0].extraKgTot = exsitingExtraKg[0].extraKgTot + d.extraKg;
                    }
                }
            }
            else {
                if (d.extraKg === 0) {
                    deductionTypes.forEach(a => {
                        if (selectedRecord[0][a] !== undefined) {
                            var tot = selectedRecord[0][a] + (d[a] === undefined ? 0 : d[a]);
                            selectedRecord[0][a] = roundNumbers(tot);
                        } else {
                            selectedRecord[0][a] = roundNumbers(d[a])
                        }
                    })

                    selectedRecord[0].netAmount = d.netAmount;
                    selectedRecord[0].grossAmount = selectedRecord[0].grossAmount + d.grossAmount;
                    selectedRecord[0].actualAmount = selectedRecord[0].actualAmount + d.actualAmount;
                    selectedRecord[0].tareWeight = checkUndifined(selectedRecord[0].tareWeight) + d.tareWeight;
                }
            }
        });

        result.forEach(x => {
            x.netAmount = x.netAmount.toFixed(2);
            x.grossAmount = x.grossAmount.toFixed(2);

            var diffrence = (x.actualAmount - x.netAmount).toFixed(2);

            x.profit = diffrence < 0 ? "Loss " + Math.abs(diffrence) : "Gain " + Math.abs(diffrence);
            x.gainLoss = diffrence;
        });

        var res = mergeDataByEmployee(result, deductionTypes, extraKgRecords);

        return res;
    }

    function mergeDataByDetailsID(data) {
        var result;

        data.forEach(d => {
            if (result === undefined) {
                var newRecord = addNewEmployee(d);
                result = newRecord;
            }
            else {
                if (result[d.deductionTypeName] !== undefined) {
                    var tot = result[d.deductionTypeName] + d.deductionAmount;
                    result[d.deductionTypeName] = roundNumbers(tot);
                } else {
                    result[d.deductionTypeName] = roundNumbers(d.deductionAmount)
                }
            }
        });

        return result;
    }

    function checkUndifined(value) {
        if (value === undefined) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function groupByDetailsID(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['pluckingCollectionDetailsID']
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {})
    }

    function mergeDataByEmployee(employees, deductionTypes, extraKg) {
        var result = [];

        var empCopy = [...employees];

        empCopy.forEach(d => {
            var selectedRecord = result.filter(e => e.employeeID === d.employeeID && e.fieldID === d.fieldID);

            if (selectedRecord.length === 0) {
                result.push(d);
            }
            else {
                deductionTypes.forEach(dt => {
                    if (selectedRecord[0][dt] !== undefined) {
                        selectedRecord[0][dt] = roundNumbers(selectedRecord[0][dt] + d[dt]);
                    }
                });

                selectedRecord[0].netAmount = parseFloat(selectedRecord[0].netAmount) + parseFloat(d.netAmount);
                selectedRecord[0].grossAmount = parseFloat(selectedRecord[0].grossAmount) + parseFloat(d.grossAmount);
                selectedRecord[0].actualAmount = parseFloat(selectedRecord[0].actualAmount) + parseFloat(d.actualAmount);
            }
        });

        empCopy.forEach(x => {
            var extraKgRecord = extraKg.filter(e => e.id === x.employeeID);

            x.extraKg = extraKgRecord.length > 0 ? extraKgRecord[0].extraKgTot : 0;

            x.actualAmount = roundNumbers(parseFloat(x.actualAmount));
            x.netAmount = roundNumbers(parseFloat(x.netAmount));
            x.grossAmount = roundNumbers(parseFloat(x.grossAmount));

            var diffrence = parseFloat(x.grossAmount - x.netAmount).toFixed(2);

            x.profit = diffrence < 0 ? "Loss " + Math.abs(diffrence) : "Gain " + Math.abs(diffrence);
            x.gainLoss = diffrence;
        })

        return result;
    }

    function addNewEmployee(data) {
        var employee = {
            collectionPointID: data.collectionPointID,
            employeeID: data.employeeID,
            epfNo: data.epfNo,
            fieldName: data.fieldName,
            firstName: data.firstName,
            collectionPointName: data.collectionPointName,
            sosTime: convertFrom24To12Format(data.sosTime) + " Session",
            weightReadTime: convertFrom24To12Format(data.weightReadTime),
            fieldID: data.fieldID,
            mobileSubSessionID: data.mobileSubSessionID,
            actualAmount: data.actualAmount,
            registrationNumber: data.registrationNumber,
            convertedEmployeeBiometricData: data.convertedEmployeeBiometricData,
            gangName: data.gangName,
            gps: data.cardReadGPS,
            netAmount: data.netAmount,
            pluckingCollectionID: data.pluckingCollectionID,
            grossAmount: data.grossAmount,
            extraKg: data.extraKg,
            tareWeight: data.tareWeight
        };

        if (data.deductionTypeName !== null) {
            employee[data.deductionTypeName] = roundNumbers(data.deductionAmount);
        }

        return employee;
    }

    function generateSummaryCard(array, dedTypes) {
        var res = [];
        var gross = 0;
        var net = 0;
        var total = 0;
        var gainLoss = 0;
        var deductionTypeTot = [];

        array.forEach(x => {
            res.push(...x);
        });

        res.forEach(val => {
            gross = gross + parseFloat(val.grossAmount);
            net = net + parseFloat(val.netAmount);
            total = total + parseFloat(val.actualAmount);
            gainLoss = gainLoss + parseFloat(val.gainLoss);

            dedTypes.forEach(x => {
                var isExsist = deductionTypeTot.find(v => v.name === x);

                if (isExsist) {
                    if (val[x] !== undefined) {
                        isExsist.value = isExsist.value + val[x];
                    }
                } else {
                    if (val[x] !== undefined) {
                        var obj = { name: x, value: val[x] };
                        deductionTypeTot.push(obj)
                    }
                }
            });
        })

        setDetailDeductions(deductionTypeTot);
        setDetailCard({
            detailCard,
            gross: gross.toFixed(2),
            net: net.toFixed(2),
            total: total.toFixed(2),
            gainloss: gainLoss.toFixed(2)
        })
    }

    function setDataForExcelData(data) {
        var res = [];
        var dataCopy = _.cloneDeep(data);

        dataCopy.forEach(x => {

            var a = _.cloneDeep(x);

            delete a[0].collectionPointID;
            delete a[0].fieldID;
            delete a[0].mobileSubSessionID;
            delete a[0].convertedEmployeeBiometricData;
            delete a[0].pluckingCollectionID;

            res.push(...a);

        });
        setExcelData(res);
    }

    const convertFrom24To12Format = (time24) => {
        const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
        const period = +sHours < 12 ? 'AM' : 'PM';
        const hours = +sHours % 12 || 12;

        return `${hours}:${minutes} ${period}`;
    }


    function roundNumbers(number) {
        return Math.round((number + Number.EPSILON) * 100) / 100
    }

    function destroyDataTable() {
        for (const [key, value] of Object.entries(sessions)) {
            $(`#${key}`).DataTable().destroy();
        }
    }

    function createDataTable() {
        for (const [key, value] of Object.entries(sessions)) {

            var t = $(`#${key}`).DataTable({
                retrieve: true,
                destroy: true,
                scrollX: true,
                "columnDefs": [{
                    "searchable": false,
                    "orderable": false,
                    "targets": 0
                }],
                "order": [[1, 'asc']]
            });

            t.on('order.dt search.dt', function () {
                t.column(0, { search: 'applied', order: 'applied' }).nodes().each(function (cell, i) {
                    cell.innerHTML = i + 1;
                });
            }).draw();
        }
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            feild: fields[searchForm.fieldID],
            date: searchForm.searchDate
        })
    }

    function generateTotalRow(mobileSubSessionID) {

        var result = totalSummaryRow.find(x => x.mobileSubSessionID === mobileSubSessionID);

        var tempRes = [];

        contentRowNames.forEach((x, i) => {
            if (i > 7) {
                for (var prop in result) {
                    if (prop === x) {
                        tempRes.push({ name: prop, value: result[prop] });
                    }
                }
            }
        });

        if (result) {
            return (
                <tr>
                    <th colSpan="8">Total</th>
                    {
                        tempRes.map((x, i) => {
                            if (x.name === "profit") {
                                return (<th key={i}></th>)
                            } else {
                                return (<th key={i} style={{ textAlign: "right" }}>{x.value.toFixed(2)}</th>)
                            }
                        })
                    }
                </tr>
            );
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef} className="card">
                        <PageHeader
                            title="Check Roll Weighment Report"
                        />
                        <div className="card-body">

                            <div className="row">
                                <div className="col">
                                    <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="groupID">Group *</InputLabel>
                                                <Select
                                                    fullWidth
                                                    id="groupID"
                                                    disabled={!permissionList.isGroupFilterEnabled}
                                                    name="groupID"
                                                    value={searchForm.groupID}
                                                    onChange={(e) => handleGroupChange(e.target)}>
                                                    <MenuItem value="0">--Select Group--</MenuItem>
                                                    {generateDropDownMenu(groups)}
                                                </Select>
                                                {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="estateID">Estate</InputLabel>
                                                <Select fullWidth
                                                    id="estateID"
                                                    name="estateID"
                                                    disabled={!permissionList.isOperationEntityFilterEnabled}
                                                    value={searchForm.estateID}
                                                    onChange={(e) => handleEstateChange(e.target)}>
                                                    <MenuItem value="0">--Select Estate--</MenuItem>
                                                    {generateDropDownMenu(estates)}
                                                </Select>
                                                {errors["estateID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>}
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="divisionID">Division *</InputLabel>
                                                <Select fullWidth
                                                    id="divisionID"
                                                    name="divisionID"
                                                    value={searchForm.divisionID}
                                                    onChange={(e) => handleDivisionChange(e.target)}>
                                                    <MenuItem value="0">--All Division--</MenuItem>
                                                    {generateDropDownMenu(divisions)}
                                                </Select>
                                                {errors["divisionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="searchDate">Date *</InputLabel>
                                                <TextField
                                                    fullWidth
                                                    id="searchDate"
                                                    name="searchDate"
                                                    type="date"
                                                    onChange={(e) => handleDateChange(e.target)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Field</InputLabel>
                                                <Select fullWidth
                                                    id="fieldID"
                                                    name="fieldID"
                                                    value={searchForm.fieldID}
                                                    onChange={(e) => handleFieldChange(e.target)}>
                                                    <MenuItem value="0">--All Field--</MenuItem>
                                                    {generateDropDownMenu(fields)}
                                                </Select>
                                                {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                            </div>
                                            <div className="col-md pb-1">
                                                <InputLabel shrink id="fieldID">Session</InputLabel>
                                                <Select fullWidth
                                                    id="sessionID"
                                                    name="sessionID"
                                                    value={searchForm.sessionID}
                                                    onChange={(e) => handleChange(e)}>
                                                    <MenuItem value="0">--All Session--</MenuItem>
                                                    {generateDropDownMenu(sessions)}
                                                </Select>
                                                {errors["sessionID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["sessionID"]}</FormHelperText>}
                                            </div>
                                        </div>

                                        <input
                                            type="submit"
                                            disabled={validate(schema, searchForm)}
                                            className="btn btn-primary"
                                            value="Generate"
                                        />
                                    </form>
                                </div>
                                <div class="w-100"></div>
                                <div className="col pl-5" 
                                style={{ maxWidth: "1460" }}
                                >
                                    {isTableHide ? null :
                                        <div>
                                            <div className="card">
                                                <div class="card-header"><h6>Weigh Details</h6></div>
                                                <div className="card-body">
                                                    <p className="d-inline pr-3"><b>Net Amount : </b> {detailCard.gross} Kg</p>
                                                    <p className="d-inline pr-3"><b>Checkroll Amount : </b>{detailCard.net} Kg</p>
                                                    <p className="d-inline pr-3"><b>Actual Amount : </b>{detailCard.total} Kg</p>
                                                    <div className="d-inline"><b>Total {detailCard.gainloss < 0 ? " Loss" : " Gain"} : </b><div className={detailCard.gainloss < 0 ? "badge badge-danger" : "badge badge-primary"}
                                                        style={{ fontSize: "14px" }}>{Math.abs(detailCard.gainloss)} Kg</div></div>
                                                    <br></br>
                                                    {detailDeductions.map((d, i) => {
                                                        return (
                                                            <p key={i} className="pt-3 d-inline pr-3"><b>{d.name} : </b>{roundNumbers(d.value)} Kg</p>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                            <div className="table-responsive row-top-gap" >
                                                {collectionCategoryReport.map((e, index) => {
                                                    return (
                                                        <div key={index} className="card shadow-none bg-light">
                                                            <div className="card-body">
                                                                <p><b>Session start time: {e[0].sosTime}</b></p>
                                                                <table
                                                                    id={e[0].mobileSubSessionID}
                                                                    className="display dataTable">
                                                                    <thead>
                                                                        <tr>
                                                                            <th></th>
                                                                            <th>EPF No</th>
                                                                            <th>FirstName</th>
                                                                            <th>Division</th>
                                                                            <th>Field</th>
                                                                            <th>Gang</th>
                                                                            <th>Session</th>
                                                                            <th>WeightRead Time</th>
                                                                            <th>Actual Amount (Kg)</th>
                                                                            <th>GPS</th>
                                                                            {feildAvailabeDedauctionTypes.map((data, index) => {
                                                                                return (
                                                                                    <th key={index}>{data}</th>
                                                                                );
                                                                            })}
                                                                            
                                                                            <th>Net Amount (Kg)</th>
                                                                            <th>Checkroll Amount (Kg)</th>
                                                                            <th>Extra Kg(Kg)</th>
                                                                            <th>Gain/ Loss (Kg)</th>
                                                                            <th>Tare Weight (Kg)</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <WeighReportContent
                                                                            data={e}
                                                                            contentRowNames={contentRowNames}
                                                                            hasEdit={false}
                                                                        />
                                                                    </tbody>
                                                                    <tfoot>
                                                                        {generateTotalRow(e[0].mobileSubSessionID)}
                                                                    </tfoot>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            {!isReportButtonsEnabled ? null :
                                                <div className="pt-2">
                                                    <ReactToPrint
                                                        documentTitle={"Check Roll Weighment Report"}
                                                        trigger={() => <input
                                                            type="button"
                                                            className="btn btn-primary pull-right ml-2"
                                                            value="Create PDF"
                                                        />}
                                                        content={() => componentRef.current}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePdf ref={componentRef} data={collectionCategoryReport} totalSummaryRow={totalSummaryRow}
                                                            lables={feildAvailabeDedauctionTypes} rowNames={contentRowNames} searchData={selectedSearchValues} weighDetails={detailCard}
                                                            detailDeductions={detailDeductions} />
                                                    </div>
                                                    <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Excel"
                                                        onClick={createFile}
                                                    />
                                                </div>}
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

